import Mitt from 'mitt'

const bus = new Mitt()

export default bus
